// count the median of a given number array
export const median = (array: number[]) => {
  array = array.sort((a, b) => {
    return a - b
  })

  var i = array.length / 2
  return i % 1 === 0 ? (array[i - 1] + array[i]) / 2 : array[Math.floor(i)]
}
